import { getToken } from "./authenticate";

export function authHeader() {
  // return authorization header with jwt token
  const currentUser = getToken();
  if (currentUser) {
    return { Authorization: `Bearer ${currentUser}` };
  } else {
    return {};
  }
}
